// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"PhoneNumberInput_inputWrapper__6SusJ","input":"PhoneNumberInput_input__m1ZOj"};